//获取文件名
export default (name) => {
  let fileName = name.lastIndexOf(".");//取到文件名开始到最后一个点的长度
  let fileFormat = name.substring(0, fileName);//截
  return fileFormat;
}
